import {urlPatterns} from '../fileUpload/fileUpload.consts';

enum FeedUploadMethod {
  FileUpload = 0,
  FromURL = 1,
  FromFTP = 2,
  FromSFTP = 3,
  FromMultipleURLs = 10,
  FromMultipleFTPURLs = 20,
  FromMultipleSFTPURLs = 30,
  SFTPGZippedFile = 40,
  GoogleSheetsViaServiceAccount = 50,
}

const fileUploadPatternMap: Record<FeedUploadMethod, RegExp> = {
  [FeedUploadMethod.FileUpload]: /.*/,
  [FeedUploadMethod.FromURL]: urlPatterns.fileUrl,
  [FeedUploadMethod.FromFTP]: urlPatterns.ftpUrl,
  [FeedUploadMethod.FromSFTP]: urlPatterns.sftpUrl,
  [FeedUploadMethod.FromMultipleURLs]: urlPatterns.multiFileUrl,
  [FeedUploadMethod.FromMultipleFTPURLs]: urlPatterns.multiFtpUrl,
  [FeedUploadMethod.FromMultipleSFTPURLs]: urlPatterns.multiSFTPUrl,
  [FeedUploadMethod.SFTPGZippedFile]: /.*/,
  [FeedUploadMethod.GoogleSheetsViaServiceAccount]: /.*/,
};

enum FeedRuleType {
  Capitalize = 0,
  Replace = 1,
  ReplaceRegex = 2,
  DefaultValue = 3,
  OverrideValue = 4,
  RegexExtract = 5,
  RemoveImagesBackground = 6,
}

enum FeedRuleTypeName {
  Capitalize = 'ChangeCapitalization',
  Replace = 'Replace',
  ReplaceRegex = 'ReplaceByRegex',
  DefaultValue = 'UseDefaultValue',
  OverrideValue = 'OverrideValue',
  RegexExtract = 'ExtractByRegex',
  RemoveImagesBackground = 'RemoveImageBackground',
}

enum FeedFileMetadataState {
  Updating = 0,
  FailedToUpdate = 1,
  ReadyForUse = 2,
  NeverRun = 3,
}

enum LocationFeedType {
  GoogleXML = 1,
  GoogleCSV = 2,
  GoogleTSV = 3,
  MappedDSV = 8,
  Custom = 9,
  MappedXML = 80,
  SportsApi = 300,
}

const feedUploadMethodByValue: Record<FeedUploadMethod, string> = {
  [FeedUploadMethod.FileUpload]: 'File Upload',
  [FeedUploadMethod.FromURL]: 'From URL',
  [FeedUploadMethod.FromFTP]: 'From FTP',
  [FeedUploadMethod.FromSFTP]: 'From SFTP',
  [FeedUploadMethod.FromMultipleURLs]: 'From Multiple URLs',
  [FeedUploadMethod.FromMultipleFTPURLs]: 'From Multiple FTP URLs',
  [FeedUploadMethod.FromMultipleSFTPURLs]: 'From Multiple SFTP URLs',
  [FeedUploadMethod.SFTPGZippedFile]: 'SFTP GZipped File',
  [FeedUploadMethod.GoogleSheetsViaServiceAccount]: 'From Google Sheet',
};

export {
  FeedUploadMethod,
  fileUploadPatternMap,
  FeedRuleType,
  FeedFileMetadataState,
  LocationFeedType,
  feedUploadMethodByValue,
  FeedRuleTypeName,
};
